<a [routerLink]="href" (click)="onGiftCardClick()">
  <div class="img-container" [ngClass]="{ 'disabled-card-container': !cardAvailable }">
    <img
      [ngClass]="{ 'img-disabled': !cardAvailable }"
      [src]="image"
      [alt]="brand"
      [attr.loading]="priorityImage ? 'eager' : 'lazy'"
    />
  </div>
  <div class="title">
    <p class="card-title-text">
      {{ brand }}
    </p>
    <ng-container *ngIf="hasAvailableTag()">
      <p *ngIf="getCashbackText()" class="cash-back-tag">
        {{ getCashbackText() }}
      </p>
      <p *ngIf="getPlainTagText()" class="cash-back-tag">
        {{ getPlainTagText() }}
      </p>
    </ng-container>
  </div>
</a>
